// REACT
import React, { Component } from "react";
// COMPONENTS
import Scanner from "./Scanner";

// LANGUAGE
let langData = require("../../Data/language.json");

export default class ScannerComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      codesToSkip: [],
      queue: [],
      fetching: false,
    };
  }
  //counter = 0;

  _onDetected = (result) => {
    let tempQueue = this.state.queue;
    if (!tempQueue.includes(result.codeResult.code)) {
      tempQueue.push(result.codeResult.code);
      this.setState({ queue: [...tempQueue] });
    }
  };

  popQueue = () => {
    if (!this.state.fetching) {
      let tempQueue = [...this.state.queue];
      let EANToFetch = tempQueue.shift();

      this.setState({
        fetching: true,
        queue: [...tempQueue],
      });

      //this.counter += 1;
      //console.log("FETCHES: ", this.counter);
      this.props.fetchEAN(EANToFetch);
    }
  };

  componentDidUpdate() {
    if (!this.state.fetching && this.state.queue > 0) {
      this.popQueue();
    }
  }

  componentWillReceiveProps(nextProp) {
    if (this.state.fetching) {
      if (nextProp.fetchedItem.succesfulFetch) {
        this.props.stopScan();
        this.setState({ queue: [] });
      } else {
        if (
          nextProp.fetchedItem.message &&
          !this.state.codesToSkip.includes(nextProp.fetchedItem.fetchedEAN)
        ) {
          let skipList = [...this.state.codesToSkip];
          skipList.push(nextProp.fetchedItem.fetchedEAN);
          this.setState({
            codesToSkip: skipList,
          });
        }
      }
      this.setState({ fetching: false });
    }
  }

  render() {
    return (
      <span style={{ position: "relative" }}>
        {this.props.scanningStatus ? (
          <Scanner
            codesToSkip={this.state.codesToSkip}
            onDetected={(result) => {
              this._onDetected(result);
            }}
          />
        ) : null}
        <div
          id="faultyCodesContainer"
          style={{
            position: "absolute",
            backgroundColor: "white",
            zIndex: 1000,
            top: "60px",
            right: "4px",
            padding: "4px 6px",
            borderRadius: "4px",
            opacity: 0.75,
          }}
        >
          <p
            style={{
              margin: "0px",
              fontWeight: 400,
            }}
          >
            {langData[this.props.language].scanner.faultyCodes}:{" "}
            {this.state.codesToSkip.length}
          </p>
        </div>
      </span>
    );
  }
}
